export default __webpack_public_path__ + "static/sso-saml-a3e831fb86cb327ccd19e083f8b8d287.png";